<span ngbTooltip='Click the "..." to expand the field.' class='pointer' *ngIf='!hasClicked' (click)='hasClicked = true'>
	{{ lessData }}...
</span>
<span *ngIf='hasClicked'>
    {{ data }}
</span>